import { render, staticRenderFns } from "./BillingREList.vue?vue&type=template&id=5ddc5694&scoped=true&"
import script from "./BillingREList.vue?vue&type=script&lang=js&"
export * from "./BillingREList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc5694",
  null
  
)

export default component.exports